(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
// NATSU MENU MOVIL — accesibilidad sin sustituir el controlador original.
(function () {
  function initNatsuMenu() {
    var header = document.getElementById('shopify-section-header');
    if (!header) return;
    var button = header.querySelector('.menu-button.w-nav-button');
    if (!button || button.dataset.natsuMenuReady) return;
    button.dataset.natsuMenuReady = 'true';
    function syncState() {
      var open = button.classList.contains('w--open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.setAttribute('aria-label', open ? 'Cerrar menú principal' : 'Abrir menú principal');
    }
    // El controlador de 2019 usa "tap"; enlazar clicks de teclado o lectores de pantalla.
    button.addEventListener('click', function (event) {
      if (event.detail === 0 && window.jQuery) {
        window.jQuery(button).triggerHandler('tap');
      }
    });
    button.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (!event.repeat) button.click();
      }
    });
    header.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && button.classList.contains('w--open')) {
        event.preventDefault();
        button.click();
        button.focus();
      }
    });
    new MutationObserver(syncState).observe(button, { attributes: true, attributeFilter: ['class'] });
    syncState();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNatsuMenu);
  } else {
    initNatsuMenu();
  }
  document.addEventListener('shopify:section:load', initNatsuMenu);
})();

  } catch(e) { console.error(e); }
})();
})();
